export default __webpack_public_path__ + "static/media/default_profile.869641e5.png";